module.exports = __webpack_public_path__ + "static/media/district8.94dc5c59.pdf";